module.exports = __webpack_public_path__ + "static/og-5c3d1a5b84accd71f640d97fbb560d7d.png";